<div class="timeline">

    <div class="timeline-item"  *ngFor="let obj of sectionInfo.array;let i = index">
      <div class="timeline-item-date"><i [class]="obj.icon"></i></div>
      <div class="timeline-item-divider"></div>
      <div class="timeline-item-content">
        <div class="timeline-item-inner">
          <div class="timeline-item-title">Paso {{i+1}}</div>
          <div class="timeline-item-text">
            <app-smart-paragraph [text]="obj.text" [limit]="130"></app-smart-paragraph>
            <img *ngIf="obj.imageUrl" [src]="obj.imageUrl" alt="">
          </div>
        </div>
      </div>
    </div>

  </div>

  